var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CBox',{attrs:{"align":"center","w":"100%","h":"100%","mx":"auto","my":"auto"}},[_c('c-spinner',{attrs:{"color":"activeMenu"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }